var _rect, _rect2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFancyCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42,
    y: 4.742,
    width: 31.839,
    height: 31.839,
    rx: 15.919,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.846 27.385a1.42 1.42 0 01-.987-.394l-4.94-4.752a1.309 1.309 0 010-1.901 1.436 1.436 0 011.976 0l3.951 3.802 8.892-8.555a1.436 1.436 0 011.975 0 1.308 1.308 0 010 1.901l-9.879 9.505c-.273.263-.63.394-.988.394z",
    fill: "url(#fancy_checkmark_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fancy_checkmark_svg__paint0_linear",
    x1: 21.316,
    y1: 15.191,
    x2: 21.316,
    y2: 27.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FDEA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DCFAE"
  })))));
}

export default __webpack_public_path__ + "./fonts/fancy_checkmark.19462e63a83f7c02047648c7f5a2318d.svg";
export { SvgFancyCheckmark as ReactComponent };